module.exports = "/dist/96166ad6756842b4f7389f7486b02181.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700italic.eot
// module id = 33
// module chunks = 0